import { useSyncExternalStore } from "react";
import type { ReadOnlyStore } from "../../src/ReadOnlyStore";

export function useShellStore<T>(store: ReadOnlyStore<T>): T {
  return useSyncExternalStore(
    (cb) => store.subscribe(cb),
    () => store.get(),
    () => store.get(),
  );
}
